module.exports = __webpack_public_path__ + "img/index-qysl4.8e8f8ae7.png";